const formSteps = ["Basic Info", "Customer Profile", "Fit", "Features", "Social Proof"];

export default formSteps;